import { z } from 'zod';

/** Shared shape for all multi-primary arrays. */
export const MultiPrimaryItemSchema = z.object({
	id: z.string(),
	name: z.string().optional(),
	isPrimary: z.boolean().optional(),
	fieldName: z.string().optional(),
	_internalId: z.string().optional()
});
